import React from 'react';
import './App.css'; // Ensure the CSS file path is correct

const Facility1 = () => {
  // Manually defined facilities
  const facilities = [
    {
      _id: '1',
      heading: 'SWIMMING POOL',
      image: `${process.env.PUBLIC_URL}/images/pacl6.webp`, // Replace with your base64 image string
    },
    {
      _id: '2',
      heading: 'GARDEN AREA',
      image: `${process.env.PUBLIC_URL}/images/shoot9.webp`, // Replace with your base64 image string
    },
    {
      _id: '3',
      heading: 'BAR AREA',
      image: `${process.env.PUBLIC_URL}/images/pacl8.webp`, // Replace with your base64 image string
    },
    {
      _id: '4',
      heading: 'ACCOMMODATION',
      image: `${process.env.PUBLIC_URL}/images/room3.webp`, // Replace with your base64 image string
    },
    {
      _id: '5',
      heading: 'FOOD AND BEVERAGE',
      image: `${process.env.PUBLIC_URL}/images/food5.webp`, // Replace with your base64 image string
    },
  ];

  return (
    <section className="facility-section" id="facilities">
      <h2 className="facility-header">OUR FACILITY</h2>
      <div className="section-container">
        <div className="facility-row">
          {facilities.length > 0 ? (
            facilities.map((facility, index) => (
              <div className="facility-item" key={facility._id}>
                <div className="facility-square">
                  <img
                    src={facility.image} // Use the provided base64 image
                  
                    className="facility-image2"
                  />
                </div>
                <p className="facility-name">{facility.heading}</p>
              </div>
            ))
          ) : (
            <p>No facilities available at the moment.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Facility1;
